import {
    ButtonGroup as ChakraButtonGroup,
    ButtonGroupProps,
    Box,
} from '@chakra-ui/react';
import { CPrimaryButton } from '../Buttons';
import {
    BorderWidth,
    Colors,
    Spacing,
    Shadows,
    BorderRadius,
    ChakraSizes,
} from '../ChakraTheme';

type Props = {
    children: React.ReactNode;
} & ButtonGroupProps;

export const CAttachedButtonGroup = ({
    children,
    size = 'sm',
    padding = Spacing.XS,
    ...rest
}: Props): JSX.Element => {
    return (
        <ChakraButtonGroup
            size={size}
            isAttached
            variant="outline"
            bg={Colors.grayCool}
            borderRadius={Spacing.XS}
            w="fit-content"
            borderWidth={BorderWidth.Thinnest}
            borderColor={Colors.gray}
            padding={padding}
            sx={{
                button: {
                    _hover: { bg: Colors.grayLight },
                    borderRadius: Spacing.XS,
                    borderColor: Colors.grayLight,
                },
            }}
            {...rest}
        >
            {children}
        </ChakraButtonGroup>
    );
};

const TabButton = ({
    label,
    isActive,
    onClick,
    testId,
    badge,
    size = ChakraSizes.lg,
}: {
    label: string;
    isActive: boolean;
    onClick: () => void;
    testId: string;
    badge?: React.ReactNode;
    size?: ChakraSizes;
}): JSX.Element => {
    return (
        <CPrimaryButton
            onClick={onClick}
            bg={isActive ? Colors.white : 'transparent'}
            testId={testId}
            color={isActive ? Colors.black : Colors.grayDark}
            borderRadius={BorderRadius.LR}
            shadow={isActive ? Shadows.XSMALL : 'none'}
            border={`${BorderWidth.Thinnest} solid`}
            borderColor={`${
                isActive ? Colors.grayLightest : 'transparent'
            } !important`} // this is being overridden
            size={size}
        >
            {label}
            {badge && <Box marginLeft={Spacing.XS}>{badge}</Box>}
        </CPrimaryButton>
    );
};

export const CStyledButtonGroup = ({
    buttons,
    size,
    ...rest
}: {
    buttons: {
        label: string;
        isActive: boolean;
        onClick: () => void;
        testId: string;
        badge?: React.ReactNode;
    }[];
    size?: ChakraSizes;
} & ButtonGroupProps): JSX.Element => {
    return (
        <CAttachedButtonGroup {...rest}>
            {buttons.map((button) => (
                <TabButton
                    key={button.label}
                    label={button.label}
                    isActive={button.isActive}
                    onClick={button.onClick}
                    testId={button.testId}
                    badge={button.badge}
                    size={size}
                />
            ))}
        </CAttachedButtonGroup>
    );
};
